import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Alert,
  Box,
  InputAdornment
} from '@mui/material';
import financeStore from '../stores/FinanceStore';

const CommissionSettingsModal = observer(({ open, onClose }) => {
  const [formData, setFormData] = useState({
    percentage: 0,
    calculationBase: 'service_price',
    taxDeductionPercent: 0
  });

  useEffect(() => {
    if (open) {
      // Load settings when modal opens
      financeStore.loadSettings();
    }
  }, [open]);

  const settings = financeStore.settings;

  useEffect(() => {
    // Populate form when settings load
    if (settings) {
      setFormData({
        percentage: settings.percentage || 0,
        calculationBase: settings.calculationBase || 'service_price',
        taxDeductionPercent: settings.taxDeductionPercent || 0
      });
    }
  }, [settings]);

  const handleChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value
    });
  };

  const handleSubmit = async () => {
    // Convert string values to numbers before sending
    const settingsData = {
      percentage: Number(formData.percentage) || 0,
      calculationBase: formData.calculationBase,
      taxDeductionPercent: Number(formData.taxDeductionPercent) || 0
    };

    const success = await financeStore.saveSettings(settingsData);
    if (success) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Configurações de Comissão</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
          {financeStore.error && (
            <Alert severity="error" onClose={() => financeStore.clearMessages()}>
              {financeStore.error}
            </Alert>
          )}

          <TextField
            label="Porcentagem Padrão"
            type="number"
            value={formData.percentage}
            onChange={handleChange('percentage')}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            inputProps={{
              min: 0,
              max: 100,
              step: 0.1
            }}
            helperText="Porcentagem de comissão padrão para a barbearia"
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel>Base de Cálculo</InputLabel>
            <Select
              value={formData.calculationBase}
              onChange={handleChange('calculationBase')}
              label="Base de Cálculo"
            >
              <MenuItem value="service_price">Preço do Serviço</MenuItem>
              <MenuItem value="paid_amount">Valor Pago</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Dedução de Impostos"
            type="number"
            value={formData.taxDeductionPercent}
            onChange={handleChange('taxDeductionPercent')}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            inputProps={{
              min: 0,
              max: 100,
              step: 0.1
            }}
            helperText="Porcentagem de impostos a deduzir antes do cálculo da comissão"
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={financeStore.isLoading}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default CommissionSettingsModal;
